// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useMemo, useState } from 'react'
import './AlertCard.scss'
import moment from 'moment/moment'
import editDots from '../../../../../images/charts/editDots.png'
import { EditToolPopUp } from '../../../../../components/edit-tool-pop-up/EditToolPopUp'
import { DELETE_TEXT, EDIT_TEXT } from '../../../../../utils/constants'

export const AlertCard = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  fullName,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  lastUpdate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  role,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  message,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  id,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setEditAlertOpened,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  editAlertOpened,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isEditAllowed,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  newAlertOpened,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setDeletedAlertId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onScrollUpAlertCard,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  IsPrivate,
}) => {
  const [isPopUpOpened, setIsPopUpOpened] = useState(false)
  const [isChangedPopUpPosition, setIsChangedPopUpPosition] = useState({})

  useEffect(() => {
    const alertsContainer = document.getElementById('AlertCard')
    if (alertsContainer) {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const clickAlertsContainerCallBack = (e) => {
        if (e.clientY >= 321) {
          if (e.clientY >= 352) {
            setIsChangedPopUpPosition({ top: -105, left: -130 })
          } else {
            setIsChangedPopUpPosition({ top: -15, left: -160 })
          }
        } else {
          setIsChangedPopUpPosition({ top: 30, left: -130 })
        }
      }
      alertsContainer.addEventListener('click', clickAlertsContainerCallBack)
      return () => {
        alertsContainer.removeEventListener('click', clickAlertsContainerCallBack)
      }
    }
  }, [])

  const togglePopUpVisibility = () => {
    setIsPopUpOpened((prev) => !prev)
  }

  useEffect(() => {
    const container = document.getElementById('container')
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const listenerCallback = (e) => {
      if (
        e.currentTarget.id !== id &&
        e.target.className !== 'edit-tool-popup-container' &&
        e.target.className !== 'edit-tool-popup-item' &&
        e.target.id !== `dots${id}`
      ) {
        setIsPopUpOpened(false)
      } else if (e.currentTarget.id === id) {
      }
    }
    container?.addEventListener('click', listenerCallback)
    return () => container?.removeEventListener('click', listenerCallback)
  }, [])

  const editToolPopupOptionsConfig = useMemo(
    () => [
      {
        name: EDIT_TEXT,
        onClickCallBack: () => {
          setEditAlertOpened({ message, alertId: id, IsPrivate })
          onScrollUpAlertCard()
          setIsPopUpOpened(false)
        },
      },
      {
        name: DELETE_TEXT,
        onClickCallBack: () => {
          setDeletedAlertId(id)
          setIsPopUpOpened(false)
        },
      },
    ],
    [message, id, IsPrivate],
  )

  return (
    <div className='alert-card-container' id={id}>
      <div className='alert-title-container'>
        <label className='alert-card-full-name bold'>{`${fullName}, ${role}`}</label>
        <div className='edit-tool-pop-up-block'>
          {!editAlertOpened && isEditAllowed && !newAlertOpened ?
            <img
              role='presentation'
              onClick={togglePopUpVisibility}
              className='alert-card-tools'
              id={`dots${id}`}
              src={editDots}
              alt='editDots'
            />
          : null}
          {isPopUpOpened ?
            <EditToolPopUp
              popUpContainerStyle={isChangedPopUpPosition}
              editToolPopUpOptions={editToolPopupOptionsConfig}
            />
          : null}
        </div>
      </div>
      <label className='alert-card-last-update-text'>
        Last updated: {moment(lastUpdate).format('MMM DD YYYY, h:mma')}
      </label>
      <label className='alert-card-message'>{message}</label>
    </div>
  )
}
